// Duplicate check response
export interface DuplicateResponse {
  isDuplicate: boolean;
  message?: string;
}

// Endpoints configuration
export interface CrudEndpoints {
  key: string;
  getList: string;
  getListById: string;
  getModal: string;
  getLookupList?: string;
  getlookupPost?: boolean;
  getListPost?: boolean;
  listPostParams?: Record<string, any>;
  idFieldName?: string;
  insert: string;
  update: string;
  delete: string;
}


export enum RecordState {
  Global = 'Global',
  Local = 'Local',
  Overridden = 'Overridden'
}
